import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
// / import withFooterLocations from 'shared/hocs/withFooterLocations';
// import Link from 'shared/components/Link/Link';
// import { injectIntl } from 'react-intl';
import { removeLocaleFromHref, toLocalized } from 'shared/helpers/locale';
import s from './LanguageList.css';

class LanguageList extends React.Component {
  static propTypes = {
    languages: PropTypes.arrayOf(
      PropTypes.shape({
        title: PropTypes.string,
        slug: PropTypes.string,
      }),
    ),
    currentPath: PropTypes.string.isRequired,
    locale: PropTypes.string.isRequired,
  };

  static defaultProps = {
    languages: [
      {
        title: 'рус',
        slug: 'ru',
      },
      {
        title: 'укр',
        slug: 'uk',
      },
    ],
  };

  render() {
    const { languages, locale, currentPath } = this.props;

    return (
      <div>
        {languages.map(item =>
          <span className={s.lang} key={item.slug}>
            {locale === item.slug
              ? <span>
                  {item.title}
                </span>
              : <a
                  href={toLocalized(removeLocaleFromHref(currentPath), item.slug)}
                  data-lang-code={item.slug}
                >
                  {item.title}
                </a>}
          </span>,
        )}
      </div>
    );
  }
}

const mapStateToProps = ({ globals, history }) => ({
  currentPath: history.currentPath,
  locale: globals.locale,
});

export default withStyles(s)(connect(mapStateToProps)(LanguageList));



// WEBPACK FOOTER //
// ./src/desktop/components/Footer/LanguageList/LanguageList.js